function BatteryPill({ value, width = 70, height }) {
    const n = Math.max(0, Math.min(100, Number(value || 0)));
    const good = n >= 80;

    // --- match your SVGs exactly ---
    const vb = good ? { w: 49, h: 21 } : { w: 49, h: 23 };

    // Outer stroke
    const stroke = good ? "#C1EFB9" : "#FF9502";
    const strokeOpacity = good ? 1 : 0.3;

    // Nub (battery head)
    const nubFill = good ? "#C1EFB9" : "#FFDFB3";

    // Inner fill
    const innerFill = good ? "#30CA17" : "#FF9502";

    // Exact geometry differences
    const outerRect = good
        ? { x: 1, y: 1, w: 43, h: 18, rx: 6 }
        : { x: 1, y: 2, w: 43, h: 18, rx: 6 };

    const innerRect = good
        ? { x: 3, y: 3, w: 39, h: 14, rx: 4 }
        : { x: 3, y: 4, w: 34, h: 14, rx: 4 };

    const nubPath = good
        ? "M46 6.5C46.7956 6.5 47.5587 6.92143 48.1213 7.67157C48.6839 8.42172 49 9.43913 49 10.5C49 11.5609 48.6839 12.5783 48.1213 13.3284C47.5587 14.0786 46.7957 14.5 46 14.5L46 10.5L46 6.5Z"
        : "M46 7.5C46.7956 7.5 47.5587 7.92143 48.1213 8.67157C48.6839 9.42172 49 10.4391 49 11.5C49 12.5609 48.6839 13.5783 48.1213 14.3284C47.5587 15.0786 46.7957 15.5 46 15.5L46 11.5L46 7.5Z";

    // Scale output size (keep aspect if height not provided)
    const outH = height ?? Math.round((width * vb.h) / vb.w);

    return (
        <span className="inline-flex items-center">
            <svg
                width={width}
                height={outH}
                viewBox={`0 0 ${vb.w} ${vb.h}`}
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                aria-label={`battery ${n}%`}
            >
                {/* nub */}
                <path d={nubPath} fill={nubFill} />

                {/* outer shell */}
                <rect
                    x={outerRect.x}
                    y={outerRect.y}
                    width={outerRect.w}
                    height={outerRect.h}
                    rx={outerRect.rx}
                    stroke={stroke}
                    strokeOpacity={strokeOpacity}
                    strokeWidth="2"
                />

                {/* inner fill (fixed width per your SVG; not a progress bar) */}
                <rect
                    x={innerRect.x}
                    y={innerRect.y}
                    width={innerRect.w}
                    height={innerRect.h}
                    rx={innerRect.rx}
                    fill={innerFill}
                />

                {/* % text (dynamic) */}
                <text
                    x="22.5"
                    y={good ? "10.5" : "11.5"} // center for each viewBox
                    textAnchor="middle"
                    dominantBaseline="middle"
                    fill="white"
                    fontSize="9"
                    fontWeight="800"
                    fontFamily="ui-sans-serif, system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial"
                >
                    {n}%
                </text>
            </svg>
        </span>
    );
}

export default BatteryPill;